import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface LmsGeneralSettings {
  id: string;
  brand_id: string;
  interest_onboarding_enabled: boolean | null;
  minimum_interests_required: number | null;
  allow_skip_interests: boolean | null;
  inactivity_days: number;
  expiry_reminder_days: number;
  lesson_clap_limit: number;
  ask_for_more_in_lesson_visible: boolean;
  digcomp_integration_enabled: boolean;
  created_at: string | null;
  updated_at: string | null;
}

export function useLmsGeneralSettings(brandId: string | null) {
  return useQuery({
    queryKey: ['lms-general-settings', brandId],
    queryFn: async () => {
      if (!brandId) return null;
      
      const { data, error } = await supabase
        .from('os_lms_general_settings')
        .select('*')
        .eq('brand_id', brandId)
        .single();
      
      if (error && error.code !== 'PGRST116') throw error;
      
      // Return with defaults if not found
      if (!data) {
        return {
          digcomp_integration_enabled: false,
        } as Partial<LmsGeneralSettings>;
      }
      
      return {
        ...data,
        digcomp_integration_enabled: (data as any).digcomp_integration_enabled ?? false,
      } as LmsGeneralSettings;
    },
    enabled: !!brandId,
  });
}
